<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>{{ pageHeading }}</h3>
            </div>
            <div class="col-12 col-md-12">
              <form [formGroup]="currentFormGroup">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <app-category-selector
                      *ngIf="isAddScreen"
                      [module]="'NA'"
                      (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Title <sup>*</sup></label>
                      <input
                        type="text"
                        class="form-control"
                        id="exampleFormControlInput1"
                        formControlName="heading"
                        placeholder=""
                        [ngClass]="{ 'is-invalid': f['heading'].errors && f['heading'].touched }" />
                      <app-validation
                        field="heading"
                        [form]="currentFormGroup"
                        [error]="{ required: 'This is a mandatory field, Kindly add heading' }"></app-validation>
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <app-company-selector
                        *ngIf="isAddScreen"
                        [showCompanyGroup]="true"
                        [isRequired]="true"
                        [showError]="showCompanySelectorError"
                        (selectedCompany)="handleCompanySelectedValue($event)"></app-company-selector>
                      <app-company-selector
                        *ngIf="!isAddScreen"
                        [showCompanyGroup]="true"
                        [isRequired]="true"
                        [companyId]="knowledgeArticle?.companyReferenceId"></app-company-selector>
                    </div>
                  </div>
                  <ng-container *ngIf="!isAddScreen">
                    <div class="col-12">
                      <div class="mb-3">
                        <label for="exampleFormControlTextarea1" class="form-label"> Content<sup>*</sup></label>
                        <div class="NgxEditor__Wrapper">
                          <quill-editor
                            class="w-100"
                            formControlName="contents"
                            [modules]="editorConfig"
                            (onEditorCreated)="onEditorCreated($event)"></quill-editor>
                        </div>
                        <app-validation
                          field="contents"
                          [form]="currentFormGroup"
                          [error]="{
                            required: 'This is a mandatory field, Kindly add description',
                            minLength: 'Description should have minimum 5 characters.',
                            maxLength: 'Max 5000 characters allowed'
                          }"></app-validation>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">YouTube Video Link</label>
                        <input
                          type="text"
                          class="form-control"
                          id="exampleFormControlInput1"
                          placeholder=""
                          formControlName="referenceVideo"
                          [ngClass]="{ 'is-invalid': f['referenceVideo'].errors && f['referenceVideo'].touched }" />
                        <app-validation
                          field="referenceVideo"
                          [form]="currentFormGroup"
                          [error]="{
                            required: 'This is a mandatory field, Kindly add reference video link',
                            pattern: 'Invalid URL format'
                          }"></app-validation>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <label class="form-check-label" for="pfRadio">Display From</label>
                          <input
                            type="date"
                            class="form-control"
                            formControlName="displayFromDatetime"
                            [ngClass]="{
                              'is-invalid': f['displayFromDatetime'].errors && f['displayFromDatetime'].touched
                            }"
                            required />
                          <app-validation
                            field="heading"
                            [form]="currentFormGroup"
                            [error]="{ invalidDate: 'Invalid Date' }"></app-validation>
                        </div>

                        <div class="col-6">
                          <label class="form-check-label" for="pfRadio">Display To</label>
                          <input
                            type="date"
                            class="form-control"
                            formControlName="displayToDatetime"
                            [ngClass]="{
                              'is-invalid': f['displayToDatetime'].errors && f['displayToDatetime'].touched
                            }"
                            required />
                          <app-validation
                            field="heading"
                            [form]="currentFormGroup"
                            [error]="{ invalidDate: 'Invalid Date' }"></app-validation>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-6">
                        <div class="mb-3">
                          <label for="exampleFormControlInput1" class="form-label">Upload Attachment</label>
                          <app-multiple-file-selector
                            [maxAllowedSizeInMB]="2"
                            (chooseFiles)="handleFileInput($event)"
                            (removeFiles)="clearSelectedFiles($event)"
                            [allowedTypes]="['application/pdf']"></app-multiple-file-selector>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="p-2">
                          <app-attachment-list
                            [referenceId]="knowledgeArticle?.id"
                            [canDownloadAll]="true"
                            [attachments]="knowledgeArticle?.documents"
                            [companyEntityId]="knowledgeArticle?.companyReferenceId"></app-attachment-list>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </form>
            </div>

            <div class="col-12 d-flex justify-content-end acvtypglastbtn mt-4" *ngIf="!isAddScreen">
              <a><button type="button" class="btn" (click)="preview()">Preview</button></a>
              <a><button type="button" class="btn" (click)="publish()">Publish</button></a>
              <a><button type="button" class="btn-discard" (click)="exit()">Exit</button></a>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn mt-4" *ngIf="isAddScreen">
              <a><button type="button" class="btn" (click)="saveBasicKnowledgeArticle()">Next</button></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="modal" [class.visible]="isPreviewVisible">
  <div class="modal-content">
    <div class="header">
      <span class="close" (click)="closeModal()" (keydown)="closeModal()">&times;</span>
    </div>
    <div class="preview-area overflow-auto">
      <ng-container #container></ng-container>
    </div>
  </div>
</div>
